/**
 * Brand mark: blue rounded badge with white lowercase "e".
 * - variant="icon": compact square, used in headers/sidebars
 * - variant="full": shows full logo image (login page, marketing)
 */
export function BrandMark({ variant = "icon", className = "" }) {
  if (variant === "full") {
    return (
      <img
        src="/acilsms-logo.png"
        alt="e-telekom"
        className={`block ${className}`}
        data-testid="brand-logo-full"
      />
    );
  }
  // icon variant: blue rounded square with white "e"
  return (
    <div
      className={`relative flex items-center justify-center bg-[#0089d0] rounded-tl-[28%] rounded-tr-[4px] rounded-br-[28%] rounded-bl-[4px] shadow-md shrink-0 ${className}`}
      data-testid="brand-mark-icon"
    >
      <span
        className="font-black text-white leading-none select-none"
        style={{
          fontFamily: "'Inter', system-ui, sans-serif",
          fontSize: "70%",
          marginTop: "-4%",
        }}
      >
        e
      </span>
    </div>
  );
}

export default BrandMark;
